<div class="text-lg font-medium mt-2">{{settings.nazev}}</div>
<div #jsoneditor></div>


